import React from 'react'
import {Link} from 'react-router-dom'
import './style.css'

const CtaSection = (props) => {
    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }
    return(
        <div className={`wpo-cta-area ${props.ctaclass}`}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="wpo-cta-text">
                            <h2>Join Us in Spreading Awareness Through Mime</h2>
                            <p>Be part of our mission to create social change through the powerful art of silent expression. Together, we can address important issues and inspire communities across Assam and beyond.</p>
                            <div className="btns">
                                <Link onClick={ClickHandler} to="/about" className="theme-btn">Learn More</Link>
                                <Link onClick={ClickHandler} to="/contact" className="theme-btn-s2">Join Our Mission</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CtaSection;